import HorizontalDividers from 'components/CustomDividers/HorizontalDividers';
import VerticalDividers from 'components/CustomDividers/VerticalDividers';
import { DialogContentStyled, Label, LeftContentWrapper, RightContentWrapper } from 'components/Dialog/DialogContent';
import { LeftContent } from 'components/Dialog/DialogLeftContent';
import { Bottom, BottomActions, ConnectButton, RightForm } from 'components/Dialog/DialogRightContent';
import { ErrorMessage, Input, InputGrid } from 'components/Form';
import WarningIcon from '@mui/icons-material/Warning';
import React, { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { getAkulakuAuthorizeUrl } from 'api/marketPlaces';
import { showAlert } from 'components/Alert';
import { channels } from 'shared/constants';
import { useAppStore } from 'stores/appStore';
import config from 'config';
import ButtonReauthorization from 'pages/Onboarding/StepTwo/ButtonReauthorization';
import ButtonAuthorization from 'pages/Onboarding/StepTwo/ButtonAuthorization';

interface FormValues {
  store_name: string;
}

interface   AkulakuConnectProps {
  chData?: {
    store_name: string;
  };
  isConnected?: boolean;
}

const AkulakuContent: React.FunctionComponent<AkulakuConnectProps> = ({ chData, isConnected = false }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm<FormValues>();
  const { indexAccordion, disablePrevButton } = useAppStore();

  const onSubmit: SubmitHandler<FormValues> = async (value) => {
    try {
      const res: any = await getAkulakuAuthorizeUrl(value.store_name, indexAccordion);
      if (res && res?.data && res?.data?.status == 'ok') {
        if (!disablePrevButton) {
          window.location.href = res?.data?.redirect;
        } else {
          location.replace(config.baseUrl);
        }
      } else {
        showAlert('error', `${res?.data?.message}`, 5000);
      }
    } catch (err) {
      const error = err as Error;
      showAlert('error', `${error}`, 5000);
    }
  };

  useEffect(() => {
    if (isConnected && chData?.store_name) {
      // Set the store name from the connected data
      setValue('store_name', chData.store_name);
    } 
  }, [isConnected, chData, setValue]);

  return (
    <DialogContentStyled>
      <LeftContentWrapper>
        <LeftContent channelId={channels.AKULAKU} />
      </LeftContentWrapper>
      <VerticalDividers />
      <RightContentWrapper>
        <RightForm id="akulaku_form" onSubmit={handleSubmit(onSubmit)}>
          <InputGrid
            label={<Label>Nama Toko</Label>}
            input={
              <Input
                isError={errors.store_name?.message ? true : false}
                type={'text'}
                placeholder={'Masukkan Nama Toko'}
                disabled={isConnected}
                {...register('store_name', {
                  required: { value: true, message: 'Nama Toko harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.store_name && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.store_name.message}
                />
              )
            }
          />
        </RightForm>
        <Bottom>
          <HorizontalDividers />
          <BottomActions>
            <ButtonReauthorization {...{
              isConnected,
              form: 'akulaku_form',
            }} />
            <ButtonAuthorization {...{
              form: 'akulaku_form',
              disable: isConnected,
            }} />
          </BottomActions>
        </Bottom>
      </RightContentWrapper>
    </DialogContentStyled>
  );
};

export default AkulakuContent;
